{
  "dashboard": {
    "Cargas de carta": "Cargas de carta",
    "Tráfico QR": "Tráfico QR",
    "Aperturas / carga": "Aperturas / carga",
    "Acciones de contacto": "Acciones de contacto",
    "Carta pública": "Carta pública",
    "Últimos 15 días · todas las sucursales": "Últimos 15 días · todas las sucursales",
    "Ver analítica →": "Ver analítica →",
    "Gestionar menú →": "Gestionar menú →",
    "Añade platos a la carta para controlar su disponibilidad desde aquí.": "Añade platos a la carta para controlar su disponibilidad desde aquí.",
    "Disponibilidad de la carta": "Disponibilidad de la carta",
    "Disponibilidad de {{name}}": "Disponibilidad de {{name}}",
    "Disponible": "Disponible",
    "Oculto": "Oculto",
    "Estado del servicio": "Estado del servicio",
    "últimos 12 meses": "últimos 12 meses",
    "últimos 30 días": "últimos 30 días",
    "Visitas registradas": "Visitas registradas",
    "Primeras visitas": "Primeras visitas",
    "Visitas recurrentes": "Visitas recurrentes",
    "Tarjetas activas": "Tarjetas activas",
    "Visita repetida": "Visita repetida",
    "Visitas": "Visitas",
    "Periodo de visitas": "Periodo de visitas",
    "30 días": "30 días",
    "12 meses": "12 meses",
    "Visitas nuevas y recurrentes durante el periodo seleccionado": "Visitas nuevas y recurrentes durante el periodo seleccionado",
    "Cuando tus clientes registren su primera visita, la tendencia aparecerá aquí.": "Cuando tus clientes registren su primera visita, la tendencia aparecerá aquí.",
    "primeras visitas ·": "primeras visitas ·",
    "recurrentes": "recurrentes",
    "Cargando visitas": "Cargando visitas",
    "Sin dominio público todavía.": "Sin dominio público todavía.",
    "Panel diario · {{branch}}": "Panel diario · {{branch}}",
    "Panel diario": "Panel diario",
    "Resumen": "Resumen",
    "Tasa VES": "Tasa VES",
    "Cambia solo. Compártelo para que tus clientes sumen sellos.": "Cambia solo. Compártelo para que tus clientes sumen sellos.",
    "Código de la sucursal": "Código de la sucursal",
    "Gestionar promociones →": "Gestionar promociones →",
    "No hay promociones activas ni programadas.": "No hay promociones activas ni programadas.",
    "Promociones": "Promociones",
    "Ver carta ↗": "Ver carta ↗",
    "Código QR": "Código QR"
  },
  "main.tsx": {
    "Unable to find root element": "No se encontró el elemento raíz"
  },
  "routes": {
    "Crea una sucursal para generar su QR y su carta.": "Crea una sucursal para generar su QR y su carta.",
    "El QR y la carta necesitan un dominio. Contacta con QMenut para asignarlo.": "El QR y la carta necesitan un dominio. Contacta con QMenut para asignarlo.",
    "Código QR": "Código QR",
    "Carta para imprimir": "Carta para imprimir",
    "QR y carta impresa": "QR y carta impresa",
    "Material para tu local": "Material para tu local",
    "QR para mesas": "QR para mesas",
    "Folletos y carteles": "Folletos y carteles",
    "Carta impresa": "Carta impresa",
    "Material para imprimir": "Material para imprimir",
    "Prepara los QR y la carta de tu local. Elige el formato y comprueba cómo quedará antes de imprimir.": "Prepara los QR y la carta de tu local. Elige el formato y comprueba cómo quedará antes de imprimir."
  },
  "shell": {
    "Resumen": "Resumen",
    "Analítica": "Analítica",
    "Menú": "Menú",
    "Promociones": "Promociones",
    "Fidelización": "Fidelización",
    "Tema": "Tema",
    "Idiomas": "Idiomas",
    "Código QR": "Código QR",
    "Sucursal": "Sucursal",
    "Usuarios": "Usuarios",
    "Ruta": "Ruta",
    "Restaurante activo": "Restaurante activo",
    "Navegación del panel": "Navegación del panel",
    "Cerrar navegación": "Cerrar navegación",
    "Ocultar navegación": "Ocultar navegación",
    "Mostrar navegación": "Mostrar navegación",
    "Cancelar": "Cancelar",
    "Descartar cambios": "Descartar cambios",
    "¿Descartar cambios?": "¿Descartar cambios?",
    "Sin dominio público": "Sin dominio público",
    "Sucursal activa": "Sucursal activa",
    "Ver carta ↗": "Ver carta ↗",
    "Cerrar sesión": "Cerrar sesión",
    "Instalar app": "Instalar app",
    "Material para imprimir": "Material para imprimir",
    "Notificaciones": "Notificaciones",
    "Mensajería": "Mensajería",
    "Reservas": "Reservas",
    "Instalar QMenut": "Instalar QMenut",
    "Se abre como una app y recibe notificaciones en este dispositivo.": "Se abre como una app y recibe notificaciones en este dispositivo.",
    "Toca Compartir y luego «Añadir a pantalla de inicio».": "Toca Compartir y luego «Añadir a pantalla de inicio».",
    "En la barra de menús, elige Archivo → «Añadir al Dock».": "En la barra de menús, elige Archivo → «Añadir al Dock».",
    "Abre el menú del navegador y elige «Instalar app» o «Añadir a pantalla de inicio». En ordenador también aparece un icono de instalar en la barra de direcciones.": "Abre el menú del navegador y elige «Instalar app» o «Añadir a pantalla de inicio». En ordenador también aparece un icono de instalar en la barra de direcciones.",
    "Entendido": "Entendido"
  },
  "analytics": {
    "Sin datos en este periodo.": "Sin datos en este periodo.",
    "Mapa": "Mapa",
    "Teléfono": "Teléfono",
    "Redes sociales": "Redes sociales",
    "WhatsApp": "WhatsApp",
    "Todos": "Todos",
    "Aún no hay suficientes cargas en ambos periodos para extraer comparaciones fiables. Necesitamos al menos 20 cargas por periodo.": "Aún no hay suficientes cargas en ambos periodos para extraer comparaciones fiables. Necesitamos al menos 20 cargas por periodo.",
    "No hay cambios destacados que señalar en este periodo.": "No hay cambios destacados que señalar en este periodo.",
    "Mejora": "Mejora",
    "Oportunidad": "Oportunidad",
    "Resumen de analítica": "Resumen de analítica",
    "Cargas de carta": "Cargas de carta",
    "Páginas cargadas, todas las sucursales": "Páginas cargadas, todas las sucursales",
    "Visitas efímeras": "Visitas efímeras",
    "No son clientes únicos": "No son clientes únicos",
    "Aperturas / carga": "Aperturas / carga",
    "Puede superar 1×": "Puede superar 1×",
    "Tráfico QR": "Tráfico QR",
    "Cargas atribuidas al enlace QR": "Cargas atribuidas al enlace QR",
    "Acciones de contacto": "Acciones de contacto",
    "Toques registrados": "Toques registrados",
    "Datos del {{range}} · agregados para todas las sucursales.": "Datos del {{range}} · agregados para todas las sucursales.",
    "Analítica": "Analítica",
    "Qué está pasando en tu carta": "Qué está pasando en tu carta",
    "Comparación": "Comparación",
    "Frente al periodo anterior": "Frente al periodo anterior",
    "Sin periodo anterior": "Sin periodo anterior",
    "Periodo de analítica": "Periodo de analítica",
    "Lecturas": "Lecturas",
    "Señales para decidir qué revisar a continuación.": "Señales para decidir qué revisar a continuación.",
    "Tráfico": "Tráfico",
    "Cómo llega la gente y cuándo abre la carta.": "Cómo llega la gente y cuándo abre la carta.",
    "Todas las sucursales": "Todas las sucursales",
    "Carta instalada": "Carta instalada",
    "Uso en modo PWA": "Uso en modo PWA",
    "Sumadas por bloque analítico": "Sumadas por bloque analítico",
    "Idiomas": "Idiomas",
    "Sucursales": "Sucursales",
    "Sucursal sin nombre": "Sucursal sin nombre",
    "Horas punta": "Horas punta",
    "No hay horas punta disponibles todavía.": "No hay horas punta disponibles todavía.",
    "cargas": "cargas",
    "Menú": "Menú",
    "Qué contenido despierta más interés.": "Qué contenido despierta más interés.",
    "Aperturas registradas": "Aperturas registradas",
    "Aperturas de platos": "Aperturas de platos",
    "Desde destacados": "Desde destacados",
    "Desde secciones": "Desde secciones",
    "Platos más abiertos": "Platos más abiertos",
    "Las aperturas de platos aparecerán aquí.": "Las aperturas de platos aparecerán aquí.",
    "{{count}} por carga": "{{count}} por carga",
    "Categorías": "Categorías",
    "Categorías alcanzadas": "Categorías alcanzadas",
    "Selecciones": "Selecciones",
    "Mayor profundidad": "Mayor profundidad",
    "Promociones": "Promociones",
    "aperturas en total": "aperturas en total",
    "Las aperturas de promociones aparecerán aquí.": "Las aperturas de promociones aparecerán aquí.",
    "Promoción sin nombre": "Promoción sin nombre",
    "Contacto y PWA": "Contacto y PWA",
    "Acciones que acercan la carta al negocio.": "Acciones que acercan la carta al negocio.",
    "Contactos": "Contactos",
    "Instalaciones": "Instalaciones",
    "Prompt aceptado": "Prompt aceptado",
    "Prompt descartado": "Prompt descartado",
    "Canales de contacto": "Canales de contacto",
    "Las acciones de contacto aparecerán aquí.": "Las acciones de contacto aparecerán aquí.",
    "Son toques registrados: no confirman que una llamada, mensaje o ruta se haya completado.": "Son toques registrados: no confirman que una llamada, mensaje o ruta se haya completado.",
    "Fidelización y premios": "Fidelización y premios",
    "Actividad de clientes identificados en D1.": "Actividad de clientes identificados en D1.",
    "Ver clientes →": "Ver clientes →",
    "Clientes con visita": "Clientes con visita",
    "Visita repetida": "Visita repetida",
    "Regresan en 30 días": "Regresan en 30 días",
    "Tarjetas activas": "Tarjetas activas",
    "Tarjetas inactivas": "Tarjetas inactivas",
    "Intervalo mediano": "Intervalo mediano",
    "Sellos acumulados": "Sellos acumulados",
    "Premios en el periodo": "Premios en el periodo",
    "Solicitados": "Solicitados",
    "Validados": "Validados",
    "Pendientes": "Pendientes",
    "Rechazados": "Rechazados",
    "Expirados": "Expirados",
    "Tiempo al primer premio": "Tiempo al primer premio",
    "Coste estimado": "Coste estimado",
    "Configura el ticket medio": "Configura el ticket medio",
    "{{count}} días": "{{count}} días",
    "{{count}} h": "{{count}} h",
    "Sin comparación": "Sin comparación",
    "Sin base comparable": "Sin base comparable",
    "Sin cambio": "Sin cambio",
    "{{count}} p.p.": "{{count}} p.p.",
    "15 días": "15 días",
    "30 días": "30 días",
    "90 días": "90 días"
  },
  "auth": {
    "Verificando…": "Verificando…",
    "Development usa el código fijo {{code}}.": "Development usa el código fijo {{code}}.",
    "Introduce el código enviado a {{email}}.": "Introduce el código enviado a {{email}}.",
    "Entrar": "Entrar",
    "Preparando…": "Preparando…",
    "Introduce el email de una cuenta provisionada.": "Introduce el email de una cuenta provisionada.",
    "Continuar": "Continuar",
    "Solicitando…": "Solicitando…",
    "Solicita un código de acceso.": "Solicita un código de acceso.",
    "Solicitar código": "Solicitar código",
    "QMenut Admin": "QMenut Admin",
    "Email": "Correo electrónico",
    "nombre@turestaurante.com": "nombre@turestaurante.com",
    "Código OTP": "Código OTP",
    "¿No te llegó el código?": "¿No te llegó el código?",
    "Reenviar en {{seconds}}s": "Reenviar en {{seconds}}s",
    "Reenviar código": "Reenviar código",
    "Propietario": "Propietario",
    "Administrador": "Administrador",
    "Equipo": "Equipo",
    "Elige un restaurante": "Elige un restaurante",
    "Tu cuenta tiene acceso a varios restaurantes. Selecciona con cuál quieres trabajar.": "Tu cuenta tiene acceso a varios restaurantes. Selecciona con cuál quieres trabajar.",
    "Tu cuenta no tiene acceso a ningún restaurante. Contacta con soporte para configurarlo.": "Tu cuenta no tiene acceso a ningún restaurante. Contacta con soporte para configurarlo.",
    "Cerrando sesión…": "Cerrando sesión…",
    "Cerrar sesión": "Cerrar sesión",
    "Introduce un email válido": "Introduce un email válido",
    "Introduce el código de 6 dígitos": "Introduce el código de 6 dígitos"
  },
  "billing": {
    "En prueba": "En prueba",
    "Activa": "Activa",
    "Pago pendiente": "Pago pendiente",
    "Cancelada": "Cancelada",
    "Básico": "Básico",
    "Facturación": "Facturación",
    "Suscripción": "Suscripción",
    "Sin suscripción": "Sin suscripción",
    "Cancelación programada.": "Cancelación programada.",
    "Gestionar {{branch}} en Stripe": "Gestionar {{branch}} en Stripe",
    "Gestionar en Stripe": "Gestionar en Stripe",
    "{{plan}} para {{branch}}": "{{plan}} para {{branch}}",
    "Business": "Business",
    "Cambiar a {{plan}}": "Cambiar a {{plan}}",
    "Con varias sucursales, cada una necesita el plan Business.": "Con varias sucursales, cada una necesita el plan Business.",
    "Probar {{plan}} 14 días": "Probar {{plan}} 14 días",
    "Suscribir {{plan}}": "Suscribir {{plan}}"
  },
  "branch": {
    "useBranchForm debe usarse dentro de BranchFormProvider": "useBranchForm debe usarse dentro de BranchFormProvider",
    "Buscando direcciones…": "Buscando direcciones…",
    "Obteniendo la ubicación…": "Obteniendo la ubicación…",
    "No se pudo obtener la ubicación del mapa. Puedes guardar la dirección sin mapa.": "No se pudo obtener la ubicación del mapa. Puedes guardar la dirección sin mapa.",
    "Has alcanzado el límite de búsquedas. Espera un minuto antes de continuar.": "Has alcanzado el límite de búsquedas. Espera un minuto antes de continuar.",
    "No se pudo buscar ahora. Puedes guardar la dirección sin mapa.": "No se pudo buscar ahora. Puedes guardar la dirección sin mapa.",
    "No hay resultados para esta búsqueda.": "No hay resultados para esta búsqueda.",
    "Dirección": "Dirección",
    "Ubicación del mapa vinculada": "Ubicación del mapa vinculada",
    "Quitar ubicación del mapa": "Quitar ubicación del mapa",
    "Selecciona una sugerencia para mostrar esta sucursal en el mapa público.": "Selecciona una sugerencia para mostrar esta sucursal en el mapa público.",
    "Reseñas de Google": "Reseñas de Google",
    "Conecta la ficha exacta de esta sucursal. Google elige y ordena las reseñas que aparecen en la página de contacto.": "Conecta la ficha exacta de esta sucursal. Google elige y ordena las reseñas que aparecen en la página de contacto.",
    "Ficha de Google Maps conectada": "Ficha de Google Maps conectada",
    "La conexión se guarda por sucursal.": "La conexión se guarda por sucursal.",
    "Abrir en Google Maps ↗": "Abrir en Google Maps ↗",
    "Cambiar": "Cambiar",
    "Desconectar": "Desconectar",
    "Buscar negocio o ficha": "Buscar negocio o ficha",
    "Nombre y dirección de la sucursal": "Nombre y dirección de la sucursal",
    "Buscando…": "Buscando…",
    "Buscar": "Buscar",
    "No se encontraron fichas para esta búsqueda.": "No se encontraron fichas para esta búsqueda.",
    "Sin valoración": "Sin valoración",
    " · {{count}} reseñas": " · {{count}} reseñas",
    "Conectar esta ficha": "Conectar esta ficha",
    "Mostrar reseñas en la página de contacto": "Mostrar reseñas en la página de contacto",
    "Conecta una ficha antes de activar las reseñas.": "Conecta una ficha antes de activar las reseñas.",
    "Redes sociales": "Redes sociales",
    "Red social": "Red social",
    "https://instagram.com/tucuenta": "https://instagram.com/tucuenta",
    "Quitar red social {{index}}": "Quitar red social {{index}}",
    "Quitar": "Quitar",
    "Agregar red social": "Agregar red social",
    "Se muestran como iconos en la página de contacto del menú público. El icono se detecta a partir del enlace.": "Se muestran como iconos en la página de contacto del menú público. El icono se detecta a partir del enlace.",
    "No se pudo preparar el logo.": "No se pudo preparar el logo.",
    "Datos guardados.": "Datos guardados.",
    "General": "General",
    "Galería": "Galería",
    "Horario": "Horario",
    "Legal": "Legal",
    "No hay ninguna sucursal disponible.": "No hay ninguna sucursal disponible.",
    "Sucursal": "Sucursal",
    "Secciones de la sucursal": "Secciones de la sucursal",
    "Galería de la sucursal": "Galería de la sucursal",
    "Identidad y contacto": "Identidad y contacto",
    "Nombre": "Nombre",
    "Teléfono": "Teléfono",
    "WhatsApp": "WhatsApp",
    "Zona horaria del restaurante": "Zona horaria del restaurante",
    "Imágenes públicas": "Imágenes públicas",
    "Logo (icono de la app)": "Logo (icono de la app)",
    "Datos legales del titular": "Datos legales del titular",
    "Razón social": "Razón social",
    "NIF/CIF": "NIF/CIF",
    "Email de protección de datos": "Email de protección de datos",
    "Estos datos aparecen en el aviso legal y la política de privacidad públicos; complétalos antes de publicar. El domicilio fiscal es la dirección de la sucursal que defines en la pestaña General.": "Estos datos aparecen en el aviso legal y la política de privacidad públicos; complétalos antes de publicar. El domicilio fiscal es la dirección de la sucursal que defines en la pestaña General.",
    "Horario semanal": "Horario semanal",
    "{{count}} franja": "{{count}} franja",
    "{{count}} franjas": "{{count}} franjas",
    "Apertura {{day}}": "Apertura {{day}}",
    "Cierre {{day}}": "Cierre {{day}}",
    "Quitar franja {{position}} de {{day}}": "Quitar franja {{position}} de {{day}}",
    "Añadir franja": "Añadir franja",
    "Añadir horario": "Añadir horario",
    "Lunes": "Lunes",
    "Martes": "Martes",
    "Miércoles": "Miércoles",
    "Jueves": "Jueves",
    "Viernes": "Viernes",
    "Sábado": "Sábado",
    "Domingo": "Domingo",
    "España peninsular — Madrid": "España peninsular — Madrid",
    "España — Islas Canarias": "España — Islas Canarias",
    "Portugal — Lisboa": "Portugal — Lisboa",
    "Reino Unido — Londres": "Reino Unido — Londres",
    "Francia — París": "Francia — París",
    "Alemania — Berlín": "Alemania — Berlín",
    "Italia — Roma": "Italia — Roma",
    "Países Bajos — Ámsterdam": "Países Bajos — Ámsterdam",
    "Bélgica — Bruselas": "Bélgica — Bruselas",
    "Suiza — Zúrich": "Suiza — Zúrich",
    "Grecia — Atenas": "Grecia — Atenas",
    "EE. UU. — Nueva York": "EE. UU. — Nueva York",
    "EE. UU. — Chicago": "EE. UU. — Chicago",
    "EE. UU. — Denver": "EE. UU. — Denver",
    "EE. UU. — Los Ángeles": "EE. UU. — Los Ángeles",
    "México — Ciudad de México": "México — Ciudad de México",
    "Colombia — Bogotá": "Colombia — Bogotá",
    "Argentina — Buenos Aires": "Argentina — Buenos Aires",
    "UTC": "UTC",
    "Hora no válida": "Hora no válida",
    "URL no válida": "URL no válida",
    "{{label}} no válida": "{{label}} no válida",
    "{{label}} fuera de rango": "{{label}} fuera de rango",
    "El nombre es obligatorio": "El nombre es obligatorio",
    "Latitud": "Latitud",
    "Longitud": "Longitud",
    "La URL debe empezar por https://": "La URL debe empezar por https://",
    "Máximo 10 redes sociales": "Máximo 10 redes sociales",
    "Email no válido": "Email no válido",
    "La zona horaria es obligatoria": "La zona horaria es obligatoria",
    "Selecciona una dirección para completar la ubicación del mapa": "Selecciona una dirección para completar la ubicación del mapa",
    "En el plan Básico la carta muestra solo la foto de portada. La galería es del plan Business.": "En el plan Básico la carta muestra solo la foto de portada. La galería es del plan Business."
  },
  "shared": {
    "Optional": "Opcional",
    "primeras visitas": "primeras visitas",
    "Selecciona…": "Selecciona…",
    "Preparando subida…": "Preparando subida…",
    "Guardando datos…": "Guardando datos…",
    "100 % transferido. Confirmando recepción…": "100 % transferido. Confirmando recepción…",
    "Subiendo archivos… {{percentage}} %": "Subiendo archivos… {{percentage}} %",
    "Transferencia de archivos": "Transferencia de archivos",
    "Espera a que termine el guardado antes de salir.": "Espera a que termine el guardado antes de salir.",
    "Guardando…": "Guardando…",
    "Guardar": "Guardar",
    "Cancelar": "Cancelar",
    "No hay resultados": "No hay resultados",
    "Buscar": "Buscar",
    "{{label}}: selector": "{{label}}: selector",
    "Error": "Error",
    "No hemos podido cargar esta vista.": "No hemos podido cargar esta vista.",
    "Reintentar": "Reintentar",
    "Volver al resumen": "Volver al resumen",
    "Cargando {{title}}": "Cargando {{title}}",
    "Cargando": "Cargando",
    "Sin sucursal": "Sin sucursal",
    "Sin dominio": "Sin dominio",
    "Esta página no existe.": "Esta página no existe.",
    "Comprueba la dirección o vuelve al panel principal.": "Comprueba la dirección o vuelve al panel principal.",
    "Claro": "Claro",
    "Oscuro": "Oscuro",
    "Tema del panel": "Tema del panel",
    "Solo cambia cómo ves QMenut en este dispositivo.": "Solo cambia cómo ves QMenut en este dispositivo.",
    "Categoría": "Categoría",
    "Plato": "Plato",
    "Extra": "Extra",
    "Grupo de variantes": "Grupo de variantes",
    "Variante": "Variante",
    "Promoción": "Promoción",
    "Sucursal": "Sucursal",
    "Recompensa": "Recompensa",
    "Descripción": "Descripción",
    "Nombre": "Nombre",
    "Eslogan": "Eslogan",
    "La traducción automática usa catalán. Puedes adaptar aquí los textos al valenciano.": "La traducción automática usa catalán. Puedes adaptar aquí los textos al valenciano.",
    "Buscar texto": "Buscar texto",
    "Secciones": "Secciones",
    "Traducción guardada.": "Traducción guardada.",
    "No se encontraron las tipografías del menú.": "No se encontraron las tipografías del menú.",
    "Apio": "Apio",
    "Crustáceos": "Crustáceos",
    "Huevos": "Huevos",
    "Pescado": "Pescado",
    "Gluten": "Gluten",
    "Altramuces": "Altramuces",
    "Leche": "Leche",
    "Moluscos": "Moluscos",
    "Mostaza": "Mostaza",
    "Frutos de cáscara": "Frutos de cáscara",
    "Cacahuetes": "Cacahuetes",
    "Sésamo": "Sésamo",
    "Soja": "Soja",
    "Sulfitos": "Sulfitos",
    "Introduce un importe válido": "Introduce un importe válido",
    "Conecta una ficha de Google antes de generar este QR.": "Conecta una ficha de Google antes de generar este QR.",
    "No se pudo transferir el archivo. Pulsa Guardar para reintentar.": "No se pudo transferir el archivo. Pulsa Guardar para reintentar.",
    "No se pudo subir el archivo. Comprueba tu conexión y pulsa Guardar.": "No se pudo subir el archivo. Comprueba tu conexión y pulsa Guardar.",
    "La subida tardó demasiado. Pulsa Guardar para reintentar.": "La subida tardó demasiado. Pulsa Guardar para reintentar.",
    "Subida interrumpida": "Subida interrumpida",
    "Los cambios sin guardar se perderán.": "Los cambios sin guardar se perderán.",
    "Platos": "Platos",
    "Extras": "Extras",
    "Promociones": "Promociones",
    "Recompensas": "Recompensas",
    "Borrar búsqueda": "Borrar búsqueda",
    "Filtrar textos": "Filtrar textos",
    "Todos ({{count}})": "Todos ({{count}})",
    "Pendientes ({{count}})": "Pendientes ({{count}})",
    "Modificados ({{count}})": "Modificados ({{count}})",
    "{{done}}/{{total}} traducidos": "{{done}}/{{total}} traducidos",
    "No hay textos en esta selección.": "No hay textos en esta selección.",
    "Guardar cambios": "Guardar cambios",
    "Cambios sin guardar: {{count}}": "Cambios sin guardar: {{count}}",
    "Modificado": "Modificado",
    "El original cambió": "El original cambió",
    "Pendiente": "Pendiente",
    "Deshacer": "Deshacer",
    "Confirmar": "Confirmar",
    "No se traducen ({{count}})": "No se traducen ({{count}})",
    "No se traduce": "No se traduce",
    "Permitir traducción": "Permitir traducción",
    "No traducir: mantener el texto original en todos los idiomas": "No traducir: mantener el texto original en todos los idiomas",
    "Disponible en Business": "Disponible en Business",
    "Disponible en el plan Business.": "Disponible en el plan Business.",
    "Esta sección está incluida en el plan Business. Tus datos se conservan.": "Esta sección está incluida en el plan Business. Tus datos se conservan.",
    "Ver planes": "Ver planes"
  },
  "exchangeRates": {
    "Sin referencia disponible": "Sin referencia disponible",
    "Sin comparación": "Sin comparación",
    "Tasa VES guardada.": "Tasa VES guardada.",
    "Precios derivados": "Precios derivados",
    "Tasa VES": "Tasa VES",
    "VES por 1 USD": "VES por 1 USD",
    "Tasa elegida": "Tasa elegida",
    "Referencia BCV": "Referencia BCV",
    "No disponible": "No disponible",
    "Fecha": "Fecha",
    "Diferencia": "Diferencia",
    "Todavía no hay una tasa configurada para este restaurante.": "Todavía no hay una tasa configurada para este restaurante.",
    "La referencia de Ming no está disponible en este momento.": "La referencia de Ming no está disponible en este momento.",
    "Mostrar precios en VES": "Mostrar precios en VES",
    "Guardando…": "Guardando…",
    "Guardar": "Guardar",
    "La referencia de Ming es informativa. Los precios públicos usan la tasa elegida por el restaurante.": "La referencia de Ming es informativa. Los precios públicos usan la tasa elegida por el restaurante.",
    "Introduce una tasa positiva con hasta seis decimales": "Introduce una tasa positiva con hasta seis decimales"
  },
  "languages": {
    "Traducciones · {{language}}": "Traducciones · {{language}}",
    "Idioma añadido, pendiente de traducción: {{error}}": "Idioma añadido, pendiente de traducción: {{error}}",
    "Idioma añadido y traducido.": "Idioma añadido y traducido.",
    "Idioma eliminado.": "Idioma eliminado.",
    "Traducción actualizada.": "Traducción actualizada.",
    "Idiomas": "Idiomas",
    "Añadir un idioma traduce el contenido de todas las sucursales. Solo se publica cuando todos los textos están completos. Selecciona un idioma para editar sus traducciones.": "Añadir un idioma traduce el contenido de todas las sucursales. Solo se publica cuando todos los textos están completos. Selecciona un idioma para editar sus traducciones.",
    "Aún no hay idiomas configurados.": "Aún no hay idiomas configurados.",
    "Idiomas disponibles": "Idiomas disponibles",
    "Publicado": "Publicado",
    "{{count}} textos pendientes · Sin publicar": "{{count}} textos pendientes · Sin publicar",
    "Por defecto": "Por defecto",
    "Acciones para {{language}}": "Acciones para {{language}}",
    "Editar traducciones": "Editar traducciones",
    "Completar traducciones": "Completar traducciones",
    "Retraducir contenido": "Retraducir contenido",
    "Eliminar": "Eliminar",
    "Procesando…": "Procesando…",
    "Acciones": "Acciones",
    "Añadir idioma": "Añadir idioma",
    "Idioma": "Idioma",
    "Traduciendo…": "Traduciendo…",
    "Añadir y traducir": "Añadir y traducir",
    "Cancelar": "Cancelar",
    "Retraducir": "Retraducir",
    "Se retraducirán todos los textos de todas las sucursales en este idioma. También se sobrescribirán tus correcciones manuales. Para conservarlas, usa Completar traducciones.": "Se retraducirán todos los textos de todas las sucursales en este idioma. También se sobrescribirán tus correcciones manuales. Para conservarlas, usa Completar traducciones.",
    "¿Retraducir todo el contenido?": "¿Retraducir todo el contenido?",
    "Elige un idioma": "Elige un idioma"
  },
  "loyalty": {
    "Buscando solicitudes": "Buscando solicitudes",
    "Reintentar lista": "Reintentar lista",
    "No hay canjes esperando. Las nuevas solicitudes aparecerán aquí.": "No hay canjes esperando. Las nuevas solicitudes aparecerán aquí.",
    "sellos ·": "sellos ·",
    "Validar {{reward}} para {{email}}": "Validar {{reward}} para {{email}}",
    "Validar": "Validar",
    "Rechazar {{reward}} para {{email}}": "Rechazar {{reward}} para {{email}}",
    "Rechazar": "Rechazar",
    "Cancelar": "Cancelar",
    "Rechazar canje": "Rechazar canje",
    "Se rechazará “{{reward}}” para {{email}}.": "Se rechazará “{{reward}}” para {{email}}.",
    "Rechazar solicitud": "Rechazar solicitud",
    "Canjes pendientes (": "Canjes pendientes (",
    "Cargando código": "Cargando código",
    "Reintentar código": "Reintentar código",
    "Código actual:": "Código actual:",
    "Programa guardado.": "Programa guardado.",
    "Premio actualizado.": "Premio actualizado.",
    "Premio creado.": "Premio creado.",
    "Premio eliminado.": "Premio eliminado.",
    "{{reward}} validado para {{email}}.": "{{reward}} validado para {{email}}.",
    "Deshacer": "Deshacer",
    "Sucursal": "Sucursal",
    "Email": "Correo electrónico",
    "Sellos": "Sellos",
    "Visitas": "Visitas",
    "Primera visita": "Primera visita",
    "Última visita": "Última visita",
    "Premios": "Premios",
    "Insights": "Estadísticas",
    "La salud del programa": "La salud del programa",
    "Indicadores de fidelización": "Indicadores de fidelización",
    "Nuevos y recurrentes": "Nuevos y recurrentes",
    "Clientes": "Clientes",
    "Tarjetas activas": "Tarjetas activas",
    "Sellos este mes": "Sellos este mes",
    "Canjes este mes": "Canjes este mes",
    "Tasa de canje": "Tasa de canje",
    "Visita repetida": "Visita repetida",
    "Periodo del gráfico": "Periodo del gráfico",
    "30 días": "30 días",
    "12 meses": "12 meses",
    "Visitas nuevas y recurrentes durante el periodo seleccionado": "Visitas nuevas y recurrentes durante el periodo seleccionado",
    "Las primeras visitas aparecerán aquí.": "Las primeras visitas aparecerán aquí.",
    "primeras visitas ·": "primeras visitas ·",
    "visitas recurrentes": "visitas recurrentes",
    "Clientes (": "Clientes (",
    "Preparando CSV…": "Preparando CSV…",
    "Exportar CSV": "Exportar CSV",
    "Buscar por email": "Buscar por email",
    "Limpiar búsqueda": "Limpiar búsqueda",
    "cliente@ejemplo.com": "cliente@ejemplo.com",
    "Sin visita en los últimos 30 días": "Sin visita en los últimos 30 días",
    "No hay clientes que coincidan con estos filtros.": "No hay clientes que coincidan con estos filtros.",
    "Página": "Página",
    "de": "de",
    "Anterior": "Anterior",
    "Siguiente": "Siguiente",
    "Operativa": "Operativa",
    "Programa": "Programa",
    "Secciones de fidelización": "Secciones de fidelización",
    "Crea una sucursal para mostrar el código de fidelización.": "Crea una sucursal para mostrar el código de fidelización.",
    "Operativa · {{branch}}": "Operativa · {{branch}}",
    "Fidelización": "Fidelización",
    "Cambia automáticamente. No hace falta tocar nada.": "Cambia automáticamente. No hace falta tocar nada.",
    "Código de esta sucursal": "Código de esta sucursal",
    "Plato gratis": "Plato gratis",
    "Descuento porcentual": "Descuento porcentual",
    "Precio especial": "Precio especial",
    "Crea una sucursal antes de configurar la fidelización.": "Crea una sucursal antes de configurar la fidelización.",
    "Sellos y premios": "Sellos y premios",
    "Configuración": "Configuración",
    "Programa activo": "Programa activo",
    "Ticket medio": "Ticket medio",
    "Guardar configuración": "Guardar configuración",
    "Crea el primer premio para que los sellos tengan una meta.": "Crea el primer premio para que los sellos tengan una meta.",
    "Vista del cliente ·": "Vista del cliente ·",
    "Tu tarjeta": "Tu tarjeta",
    "{{balance}} de {{target}} sellos": "{{balance}} de {{target}} sellos",
    "sellos": "sellos",
    "Eliminar": "Eliminar",
    "Se eliminará “{{name}}”. Esta acción no se puede deshacer.": "Se eliminará “{{name}}”. Esta acción no se puede deshacer.",
    "este premio": "este premio",
    "Eliminar premio": "Eliminar premio",
    "activo": "activo",
    "inactivo": "inactivo",
    "Acciones para {{name}}": "Acciones para {{name}}",
    "Editar": "Editar",
    "Desactivar": "Desactivar",
    "Activar": "Activar",
    "Acciones": "Acciones",
    "Editar premio": "Editar premio",
    "Nuevo premio": "Nuevo premio",
    "Premio": "Premio",
    "Nombre": "Nombre",
    "Descripción": "Descripción",
    "Premio activo": "Premio activo",
    "Canje": "Canje",
    "Tipo": "Tipo",
    "Coste en sellos": "Coste en sellos",
    "Descuento (%)": "Descuento (%)",
    "Plato · todas las sucursales": "Plato · todas las sucursales",
    "Guardar premio": "Guardar premio",
    "Premios canjeados": "Premios canjeados",
    "customers-file-name": "clientes-fidelizacion",
    "El coste debe ser un número entero de sellos": "El coste debe ser un número entero de sellos",
    "Indica un porcentaje entre 0 y 100": "Indica un porcentaje entre 0 y 100",
    "Escribe un nombre para el premio": "Escribe un nombre para el premio",
    "Selecciona un plato": "Selecciona un plato",
    "Indica un porcentaje": "Indica un porcentaje",
    "Indica un precio especial": "Indica un precio especial",
    "Pedir sellos": "Pedir sellos",
    "Solicitudes de sellos ({{count}})": "Solicitudes de sellos ({{count}})",
    "No hay solicitudes esperando. Si nadie responde, se aceptan solas a las 12 h.": "No hay solicitudes esperando. Si nadie responde, se aceptan solas a las 12 h.",
    "Se acepta sola en {{hours}} h": "Se acepta sola en {{hours}} h",
    "Sellos a aceptar": "Sellos a aceptar",
    "Un sello menos": "Un sello menos",
    "Un sello más": "Un sello más",
    "{{quantity}} de {{claimed}}": "{{quantity}} de {{claimed}}",
    "Aceptar": "Aceptar",
    "Rechazar la solicitud de {{email}}": "Rechazar la solicitud de {{email}}",
    "Rechazada": "Rechazada",
    "Aceptada sola": "Aceptada sola",
    "Aceptada {{accepted}} de {{claimed}}": "Aceptada {{accepted}} de {{claimed}}",
    "Aceptada": "Aceptada",
    "Últimas 24 h ({{count}})": "Últimas 24 h ({{count}})",
    "{{count}} sellos pedidos a las {{time}}": "{{count}} sellos pedidos a las {{time}}",
    "Deshacer la solicitud de {{email}}": "Deshacer la solicitud de {{email}}",
    "Solicitud de {{email}} rechazada.": "Solicitud de {{email}} rechazada.",
    "Máximo de sellos por solicitud": "Máximo de sellos por solicitud",
    "Indica un número entre 1 y 10": "Indica un número entre 1 y 10",
    "Aceptar la solicitud de {{email}}": "Aceptar la solicitud de {{email}}",
    "Solicitud de {{email}} aceptada.": "Solicitud de {{email}} aceptada."
  },
  "menu": {
    "No se pudo preparar la imagen.": "No se pudo preparar la imagen.",
    "Contiene alcohol": "Contiene alcohol",
    "Sin gluten": "Sin gluten",
    "Sin lactosa": "Sin lactosa",
    "Novedad": "Novedad",
    "De temporada": "De temporada",
    "Picante": "Picante",
    "Vegano": "Vegano",
    "Crea una sucursal para gestionar sus extras.": "Crea una sucursal para gestionar sus extras.",
    "Gestiona los ingredientes opcionales y asígnalos después a cada plato.": "Gestiona los ingredientes opcionales y asígnalos después a cada plato.",
    "Carta": "Carta",
    "Extras": "Extras",
    "Ingredientes opcionales": "Ingredientes opcionales",
    "Revisa el nombre y el precio del extra.": "Revisa el nombre y el precio del extra.",
    "Extra actualizado.": "Extra actualizado.",
    "Extra añadido.": "Extra añadido.",
    "Extra archivado.": "Extra archivado.",
    "Catálogo de extras (": "Catálogo de extras (",
    "Nombre": "Nombre",
    "Precio": "Precio",
    "Estado": "Estado",
    "Acciones": "Acciones",
    "Nombre del nuevo extra": "Nombre del nuevo extra",
    "Nuevo extra": "Nuevo extra",
    "Precio del nuevo extra": "Precio del nuevo extra",
    "Activo": "Activo",
    "Añadir": "Añadir",
    "Guardar": "Guardar",
    "Cancelar": "Cancelar",
    "Editar {{name}}": "Editar {{name}}",
    "Archivar {{name}}": "Archivar {{name}}",
    "Nombre de {{name}}": "Nombre de {{name}}",
    "Precio de {{name}}": "Precio de {{name}}",
    "Inactivo": "Inactivo",
    "Aún no hay extras creados.": "Aún no hay extras creados.",
    "Archivar extra": "Archivar extra",
    "«{{name}}» dejará de aparecer como opción para nuevos platos.": "«{{name}}» dejará de aparecer como opción para nuevos platos.",
    "Este extra": "Este extra",
    "¿Archivar extra?": "¿Archivar extra?",
    "Crea una sucursal para gestionar su carta.": "Crea una sucursal para gestionar su carta.",
    "Secciones de la carta": "Secciones de la carta",
    "Menú": "Menú",
    "Crear categoría": "Crear categoría",
    "Crear plato": "Crear plato",
    "Gestiona las categorías y los platos de esta sucursal.": "Gestiona las categorías y los platos de esta sucursal.",
    "Categorías": "Categorías",
    "Platos": "Platos",
    "Aún no hay categorías.": "Aún no hay categorías.",
    "Activa": "Activa",
    "Oculta": "Oculta",
    "Aún no hay platos.": "Aún no hay platos.",
    "Buscar plato": "Buscar plato",
    "Ningún plato coincide con la búsqueda.": "Ningún plato coincide con la búsqueda.",
    "Disponibilidad de {{name}}": "Disponibilidad de {{name}}",
    "Disponible": "Disponible",
    "Oculto": "Oculto",
    "Crea una sucursal para editar su carta.": "Crea una sucursal para editar su carta.",
    "Editar categoría": "Editar categoría",
    "Nueva categoría": "Nueva categoría",
    "Categoría": "Categoría",
    "Descripción": "Descripción",
    "Imagen de categoría": "Imagen de categoría",
    "Categoría activa": "Categoría activa",
    "Datos del plato": "Datos del plato",
    "Imagen del plato": "Imagen del plato",
    "Visibilidad en la carta": "Visibilidad en la carta",
    "Recomendado": "Recomendado",
    "Destacado": "Destacado",
    "La carta pública muestra un único plato estrella: el primer destacado según el orden de la carta.": "La carta pública muestra un único plato estrella: el primer destacado según el orden de la carta.",
    "Etiquetas, alérgenos y extras": "Etiquetas, alérgenos y extras",
    "Etiquetas": "Etiquetas",
    "Alérgenos": "Alérgenos",
    "Editar plato": "Editar plato",
    "Nuevo plato": "Nuevo plato",
    "Plato": "Plato",
    "Variante": "Variante",
    "El nombre es obligatorio": "El nombre es obligatorio",
    "Elige una categoría": "Elige una categoría",
    "Selecciona un plato para editarlo o crea uno nuevo.": "Selecciona un plato para editarlo o crea uno nuevo.",
    "Selecciona una categoría para editarla o crea una nueva.": "Selecciona una categoría para editarla o crea una nueva.",
    "Plato eliminado.": "Plato eliminado.",
    "Eliminar plato": "Eliminar plato",
    "¿Eliminar plato?": "¿Eliminar plato?",
    "«{{name}}» se eliminará de la carta. Esta acción no se puede deshacer.": "«{{name}}» se eliminará de la carta. Esta acción no se puede deshacer.",
    "Plato guardado.": "Plato guardado.",
    "Categoría guardada.": "Categoría guardada.",
    "Subir {{name}}": "Subir {{name}}",
    "Bajar {{name}}": "Bajar {{name}}",
    "Mostrar solo en un horario": "Mostrar solo en un horario",
    "Días visibles": "Días visibles",
    "Desde": "Desde",
    "Hasta": "Hasta",
    "Elige al menos un día": "Elige al menos un día",
    "La hora es obligatoria": "La hora es obligatoria",
    "Máximo 60 caracteres": "Máximo 60 caracteres",
    "Máximo 24 caracteres": "Máximo 24 caracteres",
    "Añade al menos dos variantes": "Añade al menos dos variantes",
    "Tamaño": "Tamaño",
    "Variantes de precio": "Variantes de precio",
    "Este plato tiene variantes de precio": "Este plato tiene variantes de precio",
    "Nombre del grupo": "Nombre del grupo",
    "15 cm": "15 cm",
    "Quitar variante {{index}}": "Quitar variante {{index}}",
    "Quitar": "Quitar",
    "Añadir variante": "Añadir variante",
    "La carta pública muestra las dos primeras variantes junto al nombre y todas en el detalle del plato. Usa etiquetas cortas (15 cm, S, XXL).": "La carta pública muestra las dos primeras variantes junto al nombre y todas en el detalle del plato. Usa etiquetas cortas (15 cm, S, XXL).",
    "Las variantes deben tener precios distintos": "Las variantes deben tener precios distintos"
  },
  "menuPrint": {
    "Categorías de la carta": "Categorías de la carta",
    "Preparando las tipografías y la carta…": "Preparando las tipografías y la carta…",
    "La carta cabe en una hoja a doble cara.": "La carta cabe en una hoja a doble cara.",
    "La carta no cabe. Desmarca categorías hasta que quepa; no se recortará ningún plato.": "La carta no cabe. Desmarca categorías hasta que quepa; no se recortará ningún plato.",
    "Selecciona al menos una categoría para imprimir.": "Selecciona al menos una categoría para imprimir.",
    "No se pudo preparar la carta. Recarga la página para volver a intentarlo.": "No se pudo preparar la carta. Recarga la página para volver a intentarlo.",
    "Del menú a la mesa": "Del menú a la mesa",
    "Carta para imprimir": "Carta para imprimir",
    "Tu plantilla, tus colores y tus fuentes. Sin fotografías y con los precios habituales.": "Tu plantilla, tus colores y tus fuentes. Sin fotografías y con los precios habituales.",
    "Formato del papel": "Formato del papel",
    "A4 a doble cara": "A4 a doble cara",
    "Una hoja vertical, anverso y reverso": "Una hoja vertical, anverso y reverso",
    "Díptico": "Díptico",
    "Una hoja horizontal, cuatro caras A5": "Una hoja horizontal, cuatro caras A5",
    "No se pudo cargar el logo. Se imprimirá el nombre del local.": "No se pudo cargar el logo. Se imprimirá el nombre del local.",
    "Imprimir / Guardar PDF": "Imprimir / Guardar PDF",
    "Elige A4, escala 100 %, sin encabezados y con gráficos de fondo. Para doble cara, gira por el borde": "Elige A4, escala 100 %, sin encabezados y con gráficos de fondo. Para doble cara, gira por el borde",
    "largo": "largo",
    "corto": "corto",
    ". Para descargar, elige «Guardar como PDF» en el diálogo de impresión.": ". Para descargar, elige «Guardar como PDF» en el diálogo de impresión.",
    "Favorito": "Favorito",
    "Recomendado": "Recomendado",
    "Alérgenos": "Alérgenos",
    "Alérgenos:": "Alérgenos:",
    "Ver carta online": "Ver carta online",
    "Exterior · contraportada y portada": "Exterior · contraportada y portada",
    "Interior · carta abierta": "Interior · carta abierta",
    "Anverso": "Anverso",
    "Reverso": "Reverso",
    "No se pudo cargar la carta o el tema de la sucursal.": "No se pudo cargar la carta o el tema de la sucursal.",
    "Reintentar": "Reintentar",
    "Tu carta todavía está vacía": "Tu carta todavía está vacía",
    "Añade categorías y platos activos al menú de esta sucursal para preparar su carta.": "Añade categorías y platos activos al menú de esta sucursal para preparar su carta.",
    "El dominio no corresponde a la sucursal seleccionada.": "El dominio no corresponde a la sucursal seleccionada."
  },
  "promotions": {
    "Menú del día": "Menú del día",
    "Happy hour": "Hora feliz",
    "Descuento porcentual": "Descuento porcentual",
    "Precio especial": "Precio especial",
    "2x1": "2x1",
    "Platos concretos": "Platos concretos",
    "Categorías": "Categorías",
    "Activa": "Activa",
    "Inactiva": "Inactiva",
    "Expirada": "Expirada",
    "Crea una sucursal para gestionar promociones.": "Crea una sucursal para gestionar promociones.",
    "Promociones": "Promociones",
    "Nueva promoción": "Nueva promoción",
    "Activas y programadas": "Activas y programadas",
    "Aún no hay promociones.": "Aún no hay promociones.",
    "Promoción no editable": "Promoción no editable",
    "Este tipo de promoción se conserva sin cambios, pero todavía no puede editarse desde este formulario.": "Este tipo de promoción se conserva sin cambios, pero todavía no puede editarse desde este formulario.",
    "Editar promoción": "Editar promoción",
    "Promoción": "Promoción",
    "Datos de la promoción": "Datos de la promoción",
    "Nombre": "Nombre",
    "Descripción": "Descripción",
    "Estado": "Estado",
    "Descuento": "Descuento",
    "Tipo": "Tipo",
    "Alcance": "Alcance",
    "Aplicar a": "Aplicar a",
    "Platos": "Platos",
    "Porcentaje (0-100)": "Porcentaje (0-100)",
    "Unidades que lleva": "Unidades que lleva",
    "Unidades que paga": "Unidades que paga",
    "Introduce un porcentaje entre 0 y 100": "Introduce un porcentaje entre 0 y 100",
    "Introduce un número entero mayor que 0": "Introduce un número entero mayor que 0",
    "El nombre es obligatorio": "El nombre es obligatorio",
    "Selecciona al menos un destino": "Selecciona al menos un destino",
    "Indica un porcentaje": "Indica un porcentaje",
    "Indica un precio": "Indica un precio",
    "Indica las unidades que lleva": "Indica las unidades que lleva",
    "Indica las unidades que paga": "Indica las unidades que paga",
    "Las unidades pagadas no pueden superar las compradas": "Las unidades pagadas no pueden superar las compradas",
    "Promoción guardada.": "Promoción guardada.",
    "Selecciona una promoción para editarla o crea una nueva.": "Selecciona una promoción para editarla o crea una nueva.",
    "Activar {{name}}": "Activar {{name}}",
    "En platos con variantes de precio se aplica a la variante más barata.": "En platos con variantes de precio se aplica a la variante más barata."
  },
  "qr": {
    "Ocultar estilos": "Ocultar estilos",
    "Estilos para imprimir": "Estilos para imprimir",
    "Descargar SVG": "Descargar SVG",
    "Copiar URL": "Copiar URL",
    "Descargar PNG": "Descargar PNG",
    "Archivo de descarga": "Archivo de descarga",
    "Elige si el código abre la carta, la ficha directa de reseñas de Google o la tarjeta de fidelización.": "Elige si el código abre la carta, la ficha directa de reseñas de Google o la tarjeta de fidelización.",
    "Destino del QR": "Destino del QR",
    "Tamaño del PNG": "Tamaño del PNG",
    "Conecta la ficha de Google de esta sucursal para generar el QR de reseñas.": "Conecta la ficha de Google de esta sucursal para generar el QR de reseñas.",
    "Abrir ajustes de sucursal": "Abrir ajustes de sucursal",
    "No se pudo cargar el tema de esta sucursal.": "No se pudo cargar el tema de esta sucursal.",
    "Reintentar": "Reintentar",
    "Escanea para ver la carta": "Escanea para ver la carta",
    "Un QR listo para tu local": "Un QR listo para tu local",
    "Elige una composición con el tema guardado de la sucursal y abre la impresión o guarda un PDF.": "Elige una composición con el tema guardado de la sucursal y abre la impresión o guarda un PDF.",
    "Imprimir / Guardar PDF": "Imprimir / Guardar PDF",
    "Estilo de impresión": "Estilo de impresión",
    "No se pudieron cargar las tipografías. Recarga la página para volver a intentarlo.": "No se pudieron cargar las tipografías. Recarga la página para volver a intentarlo.",
    "Preparando el QR y la identidad visual…": "Preparando el QR y la identidad visual…",
    "{{size}} × {{size}} px": "{{size}} × {{size}} px",
    "Carta": "Carta",
    "Reseñas de Google": "Reseñas de Google",
    "Fidelización": "Fidelización",
    "Minimal": "Minimalista",
    "A6 blanco": "A6 blanco",
    "Branded": "Con marca",
    "A6 con marca": "A6 con marca",
    "Póster": "Póster",
    "A4 vertical": "A4 vertical",
    "Póster primario": "Póster primario",
    "A4 con fondo primario": "A4 con fondo primario",
    "URL copiada.": "URL copiada.",
    "Sin marca": "Sin marca",
    "Marca sobre blanco": "Marca sobre blanco",
    "Color de marca": "Color de marca",
    "Pequeño · 4 × 4 cm": "Pequeño · 4 × 4 cm",
    "Mediano · 5 × 5 cm": "Mediano · 5 × 5 cm",
    "Grande · 6 × 6 cm": "Grande · 6 × 6 cm",
    "Pequeño · A6": "Pequeño · A6",
    "Mediano · A5": "Mediano · A5",
    "Grande · A4": "Grande · A4",
    "Póster · A3": "Póster · A3",
    "Descargar el QR para otro diseño": "Descargar el QR para otro diseño",
    "Solo el código, sin marca. Para enviarlo a tu diseñador o usarlo en otro documento.": "Solo el código, sin marca. Para enviarlo a tu diseñador o usarlo en otro documento.",
    "Listo para imprimir.": "Listo para imprimir.",
    "Selecciona al menos un destino para el folleto.": "Selecciona al menos un destino para el folleto.",
    "Indica una cantidad entre 1 y 300.": "Indica una cantidad entre 1 y 300.",
    "Esperando el tema de la sucursal. También puedes elegir «Sin marca».": "Esperando el tema de la sucursal. También puedes elegir «Sin marca».",
    "No se pudo preparar la impresión. Recarga la página para volver a intentarlo.": "No se pudo preparar la impresión. Recarga la página para volver a intentarlo.",
    "El contenido no cabe. Elige «Sin marca» o reduce los destinos del folleto.": "El contenido no cabe. Elige «Sin marca» o reduce los destinos del folleto.",
    "QR para las mesas": "QR para las mesas",
    "Folletos y carteles": "Folletos y carteles",
    "El mismo QR, tantas veces como necesites. Imprime en A4 y recorta por las guías.": "El mismo QR, tantas veces como necesites. Imprime en A4 y recorta por las guías.",
    "Tu carta, las reseñas y la fidelización, juntos o por separado en una misma página.": "Tu carta, las reseñas y la fidelización, juntos o por separado en una misma página.",
    "Tamaño de cada QR": "Tamaño de cada QR",
    "Cantidad de QR": "Cantidad de QR",
    "Qué quieres incluir": "Qué quieres incluir",
    "Tamaño del papel": "Tamaño del papel",
    "Estilo": "Estilo",
    "Sin logo ni colores. El QR se imprime negro sobre blanco.": "Sin logo ni colores. El QR se imprime negro sobre blanco.",
    "Usa el logo, los colores y las tipografías guardados de esta sucursal.": "Usa el logo, los colores y las tipografías guardados de esta sucursal.",
    "No se pudo cargar el logo. Se imprimirá el nombre del local.": "No se pudo cargar el logo. Se imprimirá el nombre del local.",
    "Imprime a escala 100 %, sin encabezados. Para descargar, elige «Guardar como PDF».": "Imprime a escala 100 %, sin encabezados. Para descargar, elige «Guardar como PDF».",
    "Activa los gráficos de fondo para imprimir el color de marca.": "Activa los gráficos de fondo para imprimir el color de marca.",
    "Vista previa de impresión": "Vista previa de impresión",
    "Vista previa": "Vista previa",
    "{{quantity}} QR · A4 · {{pages}} pág.": "{{quantity}} QR · A4 · {{pages}} pág.",
    "Tu carta en una página, lista para imprimir.": "Tu carta en una página, lista para imprimir.",
    "Idioma": "Idioma",
    "Premios": "Premios",
    "Escanea y suma sellos en cada visita": "Escanea y suma sellos en cada visita",
    "¿Te ha gustado?": "¿Te ha gustado?",
    "Déjanos una reseña en Google": "Déjanos una reseña en Google"
  },
  "theme": {
    "No disponible": "No disponible",
    "Cargando": "Cargando",
    "En directo": "En directo",
    "Vista previa de la carta": "Vista previa de la carta",
    "Vista previa": "Vista previa",
    "La carta real, antes de publicar.": "La carta real, antes de publicar.",
    "Vista previa móvil de la carta de {{host}}": "Vista previa móvil de la carta de {{host}}",
    "Cargando la carta…": "Cargando la carta…",
    "No se pudo conectar con la carta pública.": "No se pudo conectar con la carta pública.",
    "Tema guardado.": "Tema guardado.",
    "Crea una sucursal para personalizar su tema.": "Crea una sucursal para personalizar su tema.",
    "El tema se guarda por dominio. Contacta con QMenut para asignarlo.": "El tema se guarda por dominio. Contacta con QMenut para asignarlo.",
    "Tema · {{domain}}": "Tema · {{domain}}",
    "Personalización": "Personalización",
    "Guardar tema": "Guardar tema",
    "Identidad de la carta": "Identidad de la carta",
    "Elige el estilo, los colores de marca y el mensaje de bienvenida.": "Elige el estilo, los colores de marca y el mensaje de bienvenida.",
    "Plantilla": "Plantilla",
    "Color primario": "Color primario",
    "Color secundario": "Color secundario",
    "Eslogan": "Eslogan",
    "Tipografía": "Tipografía",
    "Combina una familia para los títulos con otra para el contenido de la carta.": "Combina una familia para los títulos con otra para el contenido de la carta.",
    "Tipografía de títulos": "Tipografía de títulos",
    "Tipografía de cuerpo": "Tipografía de cuerpo",
    "Fotografías": "Fotografías",
    "Estas opciones prevalecen sobre el estilo recomendado por la plantilla.": "Estas opciones prevalecen sobre el estilo recomendado por la plantilla.",
    "Mostrar fotos en la carta": "Mostrar fotos en la carta",
    "Mostrar foto al abrir un plato": "Mostrar foto al abrir un plato",
    "Bar de tapas": "Bar de tapas",
    "Alta cocina": "Alta cocina",
    "Cafetería": "Cafetería",
    "Comida rápida": "Comida rápida",
    "Herencia": "Herencia",
    "La de la plantilla": "La de la plantilla",
    "La fuente no es válida para títulos": "La fuente no es válida para títulos",
    "La fuente no es válida para el cuerpo": "La fuente no es válida para el cuerpo",
    "Color no válido": "Color no válido",
    "Máximo 120 caracteres": "Máximo 120 caracteres"
  },
  "users": {
    "La cuenta ya existía en este restaurante, así que no se envió un acceso nuevo. Puedes reenviarlo desde Acciones.": "La cuenta ya existía en este restaurante, así que no se envió un acceso nuevo. Puedes reenviarlo desde Acciones.",
    "La cuenta y la membresía se crearon, pero no se pudo enviar el acceso. Puedes reenviarlo desde Acciones.": "La cuenta y la membresía se crearon, pero no se pudo enviar el acceso. Puedes reenviarlo desde Acciones.",
    "Usuario añadido y acceso enviado.": "Usuario añadido y acceso enviado.",
    "Rol actualizado.": "Rol actualizado.",
    "Membresía reactivada.": "Membresía reactivada.",
    "Membresía desactivada.": "Membresía desactivada.",
    "No se pudo enviar el acceso. El último error ha quedado registrado para reintentar.": "No se pudo enviar el acceso. El último error ha quedado registrado para reintentar.",
    "Acceso reenviado.": "Acceso reenviado.",
    "Propietario": "Propietario",
    "Administrador": "Administrador",
    "Equipo": "Equipo",
    "Activa": "Activa",
    "Inactiva": "Inactiva",
    "Enviado": "Enviado",
    "Error": "Error",
    "Pendiente": "Pendiente",
    "Protegido": "Protegido",
    "Acciones para {{name}}": "Acciones para {{name}}",
    "Cambiar a {{role}}": "Cambiar a {{role}}",
    "Desactivar": "Desactivar",
    "Reactivar": "Reactivar",
    "Reenviar acceso": "Reenviar acceso",
    "Agregar usuario": "Agregar usuario",
    "Crea la cuenta y su acceso a este restaurante. La persona entrará solicitando un OTP, sin contraseña.": "Crea la cuenta y su acceso a este restaurante. La persona entrará solicitando un OTP, sin contraseña.",
    "Nombre": "Nombre",
    "Correo": "Correo",
    "Rol": "Rol",
    "Se enviará un correo con el acceso para iniciar sesión.": "Se enviará un correo con el acceso para iniciar sesión.",
    "Cancelar": "Cancelar",
    "Creando…": "Creando…",
    "Crear y enviar acceso": "Crear y enviar acceso",
    "Usuario": "Usuario",
    "Membresía": "Membresía",
    "Invitación": "Invitación",
    "Gestiona quién puede entrar al panel de este restaurante y con qué alcance.": "Gestiona quién puede entrar al panel de este restaurante y con qué alcance.",
    "Negocio": "Negocio",
    "Usuarios": "Usuarios",
    "Accesos del restaurante": "Accesos del restaurante",
    "persona": "persona",
    "personas": "personas",
    "Acciones": "Acciones",
    "Usuarios y membresías del restaurante": "Usuarios y membresías del restaurante",
    "Aún no hay usuarios gestionables": "Aún no hay usuarios gestionables",
    "Agrega una cuenta admin o staff para compartir el acceso al panel.": "Agrega una cuenta admin o staff para compartir el acceso al panel.",
    "Cargando usuarios…": "Cargando usuarios…",
    "Actualizando usuarios…": "Actualizando usuarios…",
    "Se bloqueará el acceso de": "Se bloqueará el acceso de",
    "a este restaurante.": "a este restaurante.",
    "Desactivar membresía": "Desactivar membresía",
    "Admin": "Administrador",
    "Staff": "Personal",
    "Escribe un nombre": "Escribe un nombre",
    "Escribe un correo válido": "Escribe un correo válido"
  },
  "common": {
    "Autenticación rechazada.": "Autenticación rechazada.",
    "No tienes permisos para realizar esta acción.": "No tienes permisos para realizar esta acción.",
    "Se ha producido un error inesperado.": "Se ha producido un error inesperado.",
    "documentTitle": "QMenut Admin"
  },
  "images": {
    "Logo de la sucursal": "Logo de la sucursal",
    "Galería de la sucursal": "Galería de la sucursal",
    "Imagen de categoría": "Imagen de categoría",
    "Imagen del plato": "Imagen del plato",
    "Imagen del plato ({{name}})": "Imagen del plato ({{name}})",
    "Vuelve a seleccionar el archivo. Los demás cambios están guardados.": "Vuelve a seleccionar el archivo. Los demás cambios están guardados.",
    "Reintento de imagen iniciado.": "Reintento de imagen iniciado.",
    "{{label}}: preparando…": "{{label}}: preparando…",
    "{{label}} actualizada": "{{label}} actualizada",
    "{{label}}: la imagen necesita atención": "{{label}}: la imagen necesita atención",
    "Reintentar": "Reintentar",
    "Pendiente de guardar": "Pendiente de guardar",
    "Subiendo": "Subiendo",
    "Procesando imagen": "Procesando imagen",
    "Archivo recibido": "Archivo recibido",
    "Error en la imagen": "Error en la imagen",
    "Selecciona una imagen JPEG, PNG o WebP.": "Selecciona una imagen JPEG, PNG o WebP.",
    "El archivo está vacío. Selecciona otra imagen.": "El archivo está vacío. Selecciona otra imagen.",
    "La imagen no puede superar 25 MiB.": "La imagen no puede superar 25 MiB.",
    "Selecciona una sola imagen.": "Selecciona una sola imagen.",
    "Arrastra tus fotos aquí": "Arrastra tus fotos aquí",
    "Arrastra aquí una imagen": "Arrastra aquí una imagen",
    "JPEG, PNG o WebP · máximo 25 MiB por imagen": "JPEG, PNG o WebP · máximo 25 MiB por imagen",
    "{{action}}: {{label}}": "{{action}}: {{label}}",
    "Foto {{index}}": "Foto {{index}}",
    "Foto movida a la posición {{index}}{{cover}}.": "Foto movida a la posición {{index}}{{cover}}.",
    ", portada": ", portada",
    "Foto {{index}} quitada. Los cambios se aplican al guardar.": "Foto {{index}} quitada. Los cambios se aplican al guardar.",
    "Elegir fotos": "Elegir fotos",
    "Añade fotos del espacio, la terraza o tus platos.": "Añade fotos del espacio, la terraza o tus platos.",
    "Has alcanzado el máximo de": "Has alcanzado el máximo de",
    "fotos. Quita una para añadir otra.": "fotos. Quita una para añadir otra.",
    "Foto {{index}}{{cover}}: {{name}}": "Foto {{index}}{{cover}}: {{name}}",
    "Reordenar {{name}}. Arrastra, o usa las flechas para moverla.": "Reordenar {{name}}. Arrastra, o usa las flechas para moverla.",
    "Portada": "Portada",
    "Usar {{name}} como portada": "Usar {{name}} como portada",
    "Usar como portada": "Usar como portada",
    "Reemplazar {{name}}": "Reemplazar {{name}}",
    "Reemplazar": "Reemplazar",
    "Quitar {{name}}": "Quitar {{name}}",
    "Quitar": "Quitar",
    "La primera foto será la portada. Los cambios se aplican al guardar.": "La primera foto será la portada. Los cambios se aplican al guardar.",
    "de": "de",
    "Seleccionar imagen": "Seleccionar imagen",
    "Quitar: {{label}}": "Quitar: {{label}}",
    "Los cambios se aplican al guardar.": "Los cambios se aplican al guardar.",
    "No se pudo preparar la imagen. Selecciona otra imagen.": "No se pudo preparar la imagen. Selecciona otra imagen.",
    "No se pudo obtener la URL de subida. Pulsa Guardar para reintentar.": "No se pudo obtener la URL de subida. Pulsa Guardar para reintentar.",
    "No se pudo subir la imagen. Pulsa Guardar para reintentar.": "No se pudo subir la imagen. Pulsa Guardar para reintentar.",
    "No se pudo inicializar el borrador de imagen.": "No se pudo inicializar el borrador de imagen.",
    "La galería admite hasta {{maximum}} imágenes.": "La galería admite hasta {{maximum}} imágenes.",
    "Ajustar logo": "Ajustar logo",
    "Arrastra para centrar y usa el zoom para encuadrar el logo.": "Arrastra para centrar y usa el zoom para encuadrar el logo.",
    "Zoom": "Zoom",
    "Cancelar": "Cancelar",
    "Aplicar": "Aplicar",
    "No se pudo recortar la imagen. Prueba con otra.": "No se pudo recortar la imagen. Prueba con otra."
  },
  "notifications": {
    "Aceptado automáticamente": "Aceptado automáticamente",
    "Activando…": "Activando…",
    "Activar en este dispositivo": "Activar en este dispositivo",
    "Caducado": "Caducado",
    "Cancelado por el cliente": "Cancelado por el cliente",
    "Canje pendiente": "Canje pendiente",
    "Cargando notificaciones": "Cargando notificaciones",
    "Crea una sucursal para recibir avisos.": "Crea una sucursal para recibir avisos.",
    "Desactivar": "Desactivar",
    "En iPhone y iPad, añade el panel a la pantalla de inicio (Compartir → Añadir a inicio) y activa las notificaciones desde allí.": "En iPhone y iPad, añade el panel a la pantalla de inicio (Compartir → Añadir a inicio) y activa las notificaciones desde allí.",
    "Este dispositivo recibe avisos de las sucursales marcadas.": "Este dispositivo recibe avisos de las sucursales marcadas.",
    "Este navegador no admite notificaciones push.": "Este navegador no admite notificaciones push.",
    "Guardar sucursales": "Guardar sucursales",
    "Instala el panel": "Instala el panel",
    "Lo que necesita tu atención en esta sucursal, de los últimos 30 días.": "Lo que necesita tu atención en esta sucursal, de los últimos 30 días.",
    "Marcar todo como leído": "Marcar todo como leído",
    "No hay notificaciones. Los avisos nuevos aparecerán aquí.": "No hay notificaciones. Los avisos nuevos aparecerán aquí.",
    "Notificaciones": "Notificaciones",
    "Notificaciones bloqueadas": "Notificaciones bloqueadas",
    "Notificaciones en este dispositivo": "Notificaciones en este dispositivo",
    "Notificaciones, {{count}} sin leer": "Notificaciones, {{count}} sin leer",
    "Permite las notificaciones de este sitio en los ajustes del navegador y vuelve a intentarlo.": "Permite las notificaciones de este sitio en los ajustes del navegador y vuelve a intentarlo.",
    "Rechazado": "Rechazado",
    "Rechazado por {{name}}": "Rechazado por {{name}}",
    "Recibe un aviso en este dispositivo cuando haya algo que atender.": "Recibe un aviso en este dispositivo cuando haya algo que atender.",
    "Reintentar": "Reintentar",
    "Resuelto": "Resuelto",
    "Sin leer": "Sin leer",
    "Sucursales": "Sucursales",
    "Validado": "Validado",
    "Validado por {{name}}": "Validado por {{name}}",
    "{{reward}} · {{cost}} sellos": "{{reward}} · {{cost}} sellos",
    "Solicitud de {{count}} sellos": "Solicitud de {{count}} sellos",
    "Solicitud de sellos": "Solicitud de sellos",
    "Aceptado": "Aceptado",
    "Aceptado por {{name}}": "Aceptado por {{name}}",
    "Reserva cancelada": "Reserva cancelada",
    "{{day}} · {{time}} · {{count}} personas": "{{day}} · {{time}} · {{count}} personas",
    "Nueva reserva": "Nueva reserva",
    "¿Activar notificaciones en este dispositivo?": "¿Activar notificaciones en este dispositivo?",
    "Ahora no": "Ahora no",
    "Enviar prueba": "Enviar prueba",
    "Prueba enviada. Debería llegar en unos segundos.": "Prueba enviada. Debería llegar en unos segundos.",
    "No se pudo enviar. Desactiva y vuelve a activar las notificaciones.": "No se pudo enviar. Desactiva y vuelve a activar las notificaciones."
  },
  "messaging": {
    "Enviar plantilla": "Enviar plantilla",
    "Plantilla": "Plantilla",
    "Teléfono (E.164)": "Teléfono (E.164)",
    "Cliente": "Cliente",
    "Restaurante": "Restaurante",
    "Fecha": "Fecha",
    "Hora": "Hora",
    "Personas": "Personas",
    "Enviar": "Enviar",
    "Conversación": "Conversación",
    "Conversaciones": "Conversaciones",
    "La ventana de 24 h está cerrada: solo se pueden enviar plantillas.": "La ventana de 24 h está cerrada: solo se pueden enviar plantillas.",
    "Respuesta": "Respuesta",
    "Responder": "Responder",
    "Mensajería": "Mensajería",
    "MSG_WORKER no está configurado en este entorno.": "MSG_WORKER no está configurado en este entorno."
  },
  "reservations": {
    "1 persona": "1 persona",
    "1 reserva": "1 reserva",
    "Aceptar reservas desde la carta": "Aceptar reservas desde la carta",
    "Ajustes": "Ajustes",
    "Ajustes guardados.": "Ajustes guardados.",
    "Antelación mínima (horas)": "Antelación mínima (horas)",
    "Añade al menos una hora para activar las reservas": "Añade al menos una hora para activar las reservas",
    "Añadir hora": "Añadir hora",
    "Cada reserva cuenta como una, sea cual sea el número de personas; a partir del máximo, la carta invita a llamar. Deja mesas para quien llega sin reservar y cierra una hora cuando se llene la sala.": "Cada reserva cuenta como una, sea cual sea el número de personas; a partir del máximo, la carta invita a llamar. Deja mesas para quien llega sin reservar y cierra una hora cuando se llene la sala.",
    "Cancelada": "Cancelada",
    "Cancelar la reserva de {{name}}": "Cancelar la reserva de {{name}}",
    "Cancelar reserva": "Cancelar reserva",
    "Cargando reservas": "Cargando reservas",
    "Cerrar el día": "Cerrar el día",
    "Cerrar la hora": "Cerrar la hora",
    "Cerrar reservas": "Cerrar reservas",
    "Cierre añadido.": "Cierre añadido.",
    "Cierres": "Cierres",
    "Cliente anónimo": "Cliente anónimo",
    "Confirmada": "Confirmada",
    "Copiar a todos los días": "Copiar a todos los días",
    "Copiar las horas del {{day}} a todos los días": "Copiar las horas del {{day}} a todos los días",
    "Crea una sucursal antes de configurar las reservas.": "Crea una sucursal antes de configurar las reservas.",
    "Día": "Día",
    "Día anterior": "Día anterior",
    "Día siguiente": "Día siguiente",
    "Días que se puede reservar por adelantado": "Días que se puede reservar por adelantado",
    "Email": "Email",
    "Escribe un número entero": "Escribe un número entero",
    "Fecha": "Fecha",
    "Guardar ajustes": "Guardar ajustes",
    "Hora": "Hora",
    "Hora de {{day}}": "Hora de {{day}}",
    "Horas de reserva": "Horas de reserva",
    "Hoy": "Hoy",
    "Indica un número entre {{min}} y {{max}}": "Indica un número entre {{min}} y {{max}}",
    "La reserva de {{name}} para el {{when}} se cancela, la mesa queda libre y el cliente recibe un email. No se puede deshacer.": "La reserva de {{name}} para el {{when}} se cancela, la mesa queda libre y el cliente recibe un email. No se puede deshacer.",
    "La reserva queda hecha al momento. El cliente recibe un email y un recordatorio con un enlace para confirmar o cancelar; si no confirma, mantiene su mesa.": "La reserva queda hecha al momento. El cliente recibe un email y un recordatorio con un enlace para confirmar o cancelar; si no confirma, mantiene su mesa.",
    "Las horas a las que se puede llegar cada día, en la hora del restaurante.": "Las horas a las que se puede llegar cada día, en la hora del restaurante.",
    "Máximo de personas por reserva": "Máximo de personas por reserva",
    "No hay cierres programados.": "No hay cierres programados.",
    "No hay reservas este día.": "No hay reservas este día.",
    "Para festivos, eventos privados o reservas tomadas por teléfono. Las reservas que ya existen no se cancelan.": "Para festivos, eventos privados o reservas tomadas por teléfono. Las reservas que ya existen no se cancelan.",
    "Próximos cierres": "Próximos cierres",
    "Quitar": "Quitar",
    "Quitar {{time}} del {{day}}": "Quitar {{time}} del {{day}}",
    "Reabrir": "Reabrir",
    "Reabrir {{closure}}": "Reabrir {{closure}}",
    "Recordatorio por email (horas antes)": "Recordatorio por email (horas antes)",
    "Reintentar": "Reintentar",
    "Reserva de {{name}} cancelada.": "Reserva de {{name}} cancelada.",
    "Reservas": "Reservas",
    "Reservas online": "Reservas online",
    "Reservas online por hora": "Reservas online por hora",
    "Secciones de reservas": "Secciones de reservas",
    "Sin confirmar": "Sin confirmar",
    "Sin reservas": "Sin reservas",
    "Teléfono": "Teléfono",
    "Todo el día": "Todo el día",
    "Volver": "Volver",
    "todo el día": "todo el día",
    "{{count}} personas": "{{count}} personas",
    "{{count}} reservas": "{{count}} reservas",
    "{{held}} de {{capacity}} reservas": "{{held}} de {{capacity}} reservas",
    "¿Cancelar esta reserva?": "¿Cancelar esta reserva?"
  }
}
